import { createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';

import type {
  I_CustomerLoyaltyContext,
  I_CustomerLoyaltyResponse,
} from '@/types/RegisteredCustomer';

const CustomerLoyaltyContext = createContext<I_CustomerLoyaltyContext | undefined>(undefined);

export const useCustomerLoyalty = (): I_CustomerLoyaltyContext => {
  const context = useContext(CustomerLoyaltyContext);
  if (!context) {
    throw new Error('useCustomerLoyalty must be used within a CustomerLoyaltyProvider');
  }
  return context;
};

export const CustomerLoyaltyProvider = ({ children }: { children: preact.ComponentChildren }) => {
  const [customerLoyalty, setCustomerLoyalty] = useState<I_CustomerLoyaltyResponse | null>(null);
  const [pointsToRedeem, setPointsToRedeem] = useState(0);

  return (
    <CustomerLoyaltyContext.Provider
      value={{
        customerLoyalty,
        setCustomerLoyalty,
        pointsToRedeem,
        setPointsToRedeem,
      }}
    >
      {children}
    </CustomerLoyaltyContext.Provider>
  );
};
